import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { BrandMark } from "../../lib/icons";
import { useSettings } from "../../context/SettingsContext";
import { setToken } from "../../lib/api";

const I = {
  dash: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>,
  leads: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 5h16v14H4z"/><path d="M4 7l8 6 8-6"/></svg>,
  ops: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 21V8l7-4 7 4v13"/><path d="M10 21v-6h4v6M21 21H3"/></svg>,
  ac: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"><path d="M2 13l8-2 7-6c1-.8 2.5 0 2 1.3L16 11l5 1v2l-5 .5-3 5.5h-2l1-5.5-6 .5-2 2H2l1-2.5z"/></svg>,
  set: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M19 12a7 7 0 0 0-.1-1l2-1.6-2-3.4-2.4 1a7 7 0 0 0-1.7-1L16.5 3h-4l-.3 2.4a7 7 0 0 0-1.7 1l-2.4-1-2 3.4 2 1.6a7 7 0 0 0 0 2l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 1.7 1l.3 2.6h4l.3-2.6a7 7 0 0 0 1.7-1l2.4 1 2-3.4-2-1.6c.1-.3.1-.7.1-1z"/></svg>,
};

export default function AdminLayout() {
  const s = useSettings();
  const nav = useNavigate();
  const logout = () => { setToken(""); nav("/login", { replace: true }); };
  return (
    <div className="adm">
      <aside className="adm-side">
        <div className="adm-brand"><BrandMark /><span>{s.brand}</span></div>
        <div className="sub">Broker CRM</div>
        <nav className="adm-nav">
          <NavLink end to="/admin" className={({ isActive }) => (isActive ? "active" : "")}>{I.dash}<span>Dashboard</span></NavLink>
          <NavLink to="/admin/leads" className={({ isActive }) => (isActive ? "active" : "")}>{I.leads}<span>Leads</span></NavLink>
          <NavLink to="/admin/operators" className={({ isActive }) => (isActive ? "active" : "")}>{I.ops}<span>Operators</span></NavLink>
          <NavLink to="/admin/aircraft" className={({ isActive }) => (isActive ? "active" : "")}>{I.ac}<span>Aircraft</span></NavLink>
          <NavLink to="/admin/settings" className={({ isActive }) => (isActive ? "active" : "")}>{I.set}<span>Settings</span></NavLink>
          <Link to="/" style={{ marginTop: 18, color: "#A7A29D" }}>{"\u2190"}<span>&nbsp;View website</span></Link>
          <button className="adm-logout" type="button" onClick={logout}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18, flex: "none" }}><path d="M16 17l5-5-5-5M21 12H9M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /></svg>
            <span>Sign out</span>
          </button>
        </nav>
      </aside>
      <main className="adm-main"><Outlet /></main>
    </div>
  );
}
